interface IDebouncerConfiguration {
  delayInMs?: number;
  // cannot create a circular reference by using CallbackParams. Instead use any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (...params: any) => void;
}

type CallbackParams = IDebouncerConfiguration['callback'];

interface IDebouncer {
  debounce: (...params: Parameters<CallbackParams>) => void;
  clearDebounce: () => void;
}

export function Debouncer({ delayInMs = 200, callback }: Readonly<IDebouncerConfiguration>): IDebouncer {
  let timer: ReturnType<typeof setTimeout> | undefined;

  function debounce(...params: Parameters<CallbackParams>) {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => callback(...params), delayInMs);
  }

  function clearDebounce() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  return { debounce, clearDebounce };
}
